import { render } from "./SideBarLink.vue?vue&type=template&id=784ca788&ts=true"
import script from "./SideBarLink.vue?vue&type=script&lang=ts"
export * from "./SideBarLink.vue?vue&type=script&lang=ts"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__